export default {
  SET_purchase(state, value) {
    state.purchase = value;
  },
  SET_purchases(state, value) {
    state.purchases = value;
  },
};
